// Базовый URL для API
import config from '../config/environment';

export const API_URL = config.apiUrl; 